import React from 'react';

import HomeContainer, { HomeData } from 'container/Home';

const Home: React.FC<BasePageDataTypes<HomeData>> = (props) => (
  <HomeContainer {...props} />
);

export default Home;
